import React from 'react'

import RecipesOverviewWrapper from '../../../react4xp/components/RecipesOverviewWrapper'

function RecipesOverviewPart({title, endpoint, recipeTypes, startValues, strings}) {
	return (
		<RecipesOverviewWrapper 
			title={title}
			endpoint={endpoint}
			types={recipeTypes}
			startValues={startValues}
			strings={strings}
		/>
	)
}

export default (props) => <RecipesOverviewPart {...props} />
